export enum QuestionsEnum {
    fiveStars = 'TIPO_RESP_ESTRELA_1_5',
    dissertation = 'TIPO_RESP_DISSERTACAO',
    yesOrNo = 'TIPO_RESP_ALTERNATIVA_S_N'
}